var currentUrlArr = location.pathname.split("/");
var actor = currentUrlArr[1];

// 実費処理
$(() => {
    // 初期実行
    if ($('#js-regist-report-cost') != null) {
        addRemoveButton();
    }

    //実費>行追加
    $(document).on("click", '.js-add-report-cost', function(e) {
        e.preventDefault();
        let template = $('.js-dynamic-row-content').find('.js-dynamic-row').last();
        let row = template.clone(true);
        let newId = row.data('id') + 1;
        row.attr('data-id', newId);
        $(row.find('select')).attr('id', 'cost-' + newId);
        $($(row).find('input, textarea')).removeClass('is-invalid');

        row.find('.js-selectedFiles').html('');
        row.find('.js-registedFiles').html('');
        row.find('.js-report_cost_file_ids').val('');
        row.find('input, textarea').each(function(){
            // valueの初期化
            $(this).val('');
            $(this).height('auto');
        });
        row.find('select').val('');
        row.find('input[type=checkbox]').prop({'checked': false, 'value': 1});
        template.after(row);

        // name 番号振り直し
        let rows = $('.js-dynamic-row-content').find('.js-dynamic-row');
        rows.each(function (idx) {
            let name = 'report_costs[nonbillable_flag][' + idx +']';
            $(this).find('input[type=checkbox]').attr('name', name);
        });

        addRemoveButton();
    });

    //実費>行削除
    $(document).on("click", '.js-remove-report-cost', function(e) {
        e.preventDefault();
        let rows = $(this).parents('.js-dynamic-row-content').find('.js-dynamic-row');

        // 削除対象の行に未保存のファイルが登録されていれば削除（保存済みファイルはFormをPOST後に削除処理します）
        $.each(rows.find('.js-report_cost_file'),function(){
            if($(this).data('registed') !== 'registed'){
                ajaxRemoveCostFile($(this).data('file-id'));
            }
        });

        if (rows.length > 1) {
            $(this).parents('.js-dynamic-row').fadeOut(300).queue(function() {
              this.remove();
            });

            // name 番号振り直し
            let removableRows = $(this).parents('.js-dynamic-row-content').find('.js-remove-report-cost');
            let unremovableRowLength = rows.length - removableRows.length;
            let removeRowIndex = removableRows.index(this);
            let threshold = removeRowIndex + unremovableRowLength;
            $.each(rows.find('input[type=checkbox]'),function(idx) {
                let num = idx >= threshold ? idx - 1 : idx;
                let name = 'report_costs[nonbillable_flag][' + num + ']';
                $(this).attr('name', name);
            });
        } else {
            let row = rows.last();
            // domの初期化
            row.find('.js-selectedFiles').html('');
            row.find('.js-registedFiles').html('');
            row.find('.js-report_cost_file_ids').val('');
            row.find('input, textarea').each(function(){
                $(this).val('');
                $(this).height('auto');
            });
            row.find('select').val('');
            row.find('input[type=checkbox]').attr('name', 'report_costs[nonbillable_flag][0]').prop('checked', false);
        }
    });

    // 領収書ファイルUP処理
    $(document).on('change', '.js-report-cost-file', function(){
        // 最大アップロードファイルサイズ
        const maxFileSize = 10485760;
        const maxFileSizeStr = '10MB';
        // 既にアップロードエラーメッセージが表示されている場合は一旦削除
        $('#report-cost-errors').find('.upload-error').remove();
        $(this).closest('td').find('.report-cost-file-upload-form').removeClass('form-control').removeClass('is-invalid');

        // アップロードファイルの取得
        let fileEntity = $(this)[0].files[0];
        let error = '';
        if (fileEntity === undefined) {
            error = 'ファイルのアップロードに失敗しました。再度お試しください。';
        } else if (fileEntity.size > maxFileSize) {
            error = 'アップロードファイルのサイズが最大値を超えました。最大アップロードサイズ：' + maxFileSizeStr;
        }

        if (error.length > 0) {
            $('#report-cost-errors').append('<span class="invalid-feedback upload-error" role="alert"><strong>' + error + '</strong>');
            $(this).closest('td').find('.report-cost-file-upload-form').addClass('form-control').addClass('is-invalid');
            return;
        }

        // リクエストデータ作成
        let formData = new FormData();
        formData.append("report_id", $('#js-report_id').val() );
        formData.append("costFile", fileEntity);
        // カンマ区切りid
        let targetInput = $(this).closest('td').find('.js-report_cost_file_ids');

        // アップロード処理
        $.ajax({
            url: '/'+actor+'/ajax/registReportCostFile',
            type: 'POST',
            processData: false,
            contentType: false,
            dataType : 'json',
            data: formData
        }).done(function(data, textStatus, jqXHR) {
            // 配列に変換
            let valArray = targetInput[0]? targetInput.val().split(","):[];
            // 配列に追加
            valArray.push(data);
            // 不要な要素を削除して文字列に変換
            targetInput.val(valArray.filter(Boolean).join(','));

            let target = targetInput.closest('td').find('.js-selectedFiles');
            target.append( addedFileTemplate(fileEntity.name,data) );
            // ツールチップ適応
            target.find('[data-toggle="tooltip"]').tooltip();

        }).fail(function(jqXHR, textStatus, errorThrown ) {
            let error = 'ファイルのアップロードに失敗しました。';
            if (jqXHR.status === 413) {
                error += '最大アップロードサイズ：' + maxFileSizeStr;
            }
            $('#report-cost-errors').append('<span class="invalid-feedback upload-error" role="alert"><strong>' + error + '</strong></span>');
            targetInput.closest('td').find('.report-cost-file-upload-form').addClass('form-control').addClass('is-invalid');
        });
    });

    $(document).on('click', '.js-report_cost_file_remove', function(){
        let fileId = $(this).closest('.js-report_cost_file').data('file-id');
        let targetInput = $(this).closest('td').find('.js-report_cost_file_ids');
        let valArray = targetInput[0]? targetInput.val().split(","):[];
        // 配列から削除
        let idx = valArray.indexOf(String(fileId));
        // 直近の親要素を取得してその中にあるinput要素(type="file")を取得する(アップロードしたファイル情報を持っている)
        let reportCostFile = $(this).closest('.js-dynamic-row').find('.js-report-cost-file');

        if(idx >= 0){
            valArray.splice(idx, 1);
        }

        // 不要な要素を削除して文字列に変換
        targetInput.val(valArray.join(','));
        // 表示も削除
        $(this).closest('.report_cost_file').remove();
        // 続けて同じファイルをアップロードしようとすると、changeイベントが発生しないのでvalueをクリアする
        reportCostFile.val('');

        // 新規ファイルの場合は実体も削除
        if( $(this).closest('.js-report_cost_file').data('registed') !== 'registed' ){
            ajaxRemoveCostFile(fileId);
        }
    });

    // Ajax領収書ファイル削除
    function ajaxRemoveCostFile(fileId) {
        const actor = window.location.pathname.split('/')[1];
        const url = '/' + actor + '/ajax/removeReportCostFile';
        $.ajax({
            url: url,
            type: 'POST',
            dataType : 'json',
            data: {
                file_id:fileId
            },
        }).done(function(data, textStatus, jqXHR) {
            return true;
        }).fail(function(jqXHR, textStatus, errorThrown ) {
            return false;
        }).always(function(){
            return false;
        });
    }

    // ファイル選択時のファイル名表示テンプレート
    var addedFileTemplate = function(filename, fileId) {
        var template = $($('div#reportCostAttachedFile').html());
        template.attr('data-file-id', fileId);
        template.find('.report_cost_file_name').attr('title', filename).text(filename);
        return template
    }

    const search = ['', '宿泊費', 'その他(費目に記載)'];
    $(document).on('change', 'select[name="report_costs[usage][]"]', function(){
        let row = $(this).parent().parent();
        let usage = $(this).val();
        // 分類の更新
        // 費目のプレースホルダーと往復／片道セレクトボックスの制御
        if (usage === '' || usage === 'タクシー' || usage === '宿泊費' || usage.startsWith('その他')) {
            row.find('textarea[name="report_costs[title][]"]').attr('placeholder', '例）雑費');
            row.find('select[name="report_costs[route][]"]').val('').addClass('select-disabled');
            row.find('select[name="report_costs[route][]"] option').not(':first').hide();
        } else {
            row.find('textarea[name="report_costs[title][]"]').attr('placeholder', '例）新宿→原宿');
            row.find('select[name="report_costs[route][]"]').removeClass('select-disabled');
            row.find('select[name="report_costs[route][]"] option').show();
        }

        // 税率の更新
        let tax_rate = null;
        if (usage === '') {
            tax_rate = null;
        } else if (usage === 'その他(8%対象)') {
            tax_rate = 8;
        } else {
            tax_rate = 10;
        }
        let tax_rate_str = tax_rate === null ? '' : (tax_rate + '%');
        row.find('.tax_rate_str').text(tax_rate_str);
        row.find(':hidden[name="report_costs[tax_rate][]"]').val(tax_rate);
    });

    // ページ読み込み時の初期化処理
    $(document).ready(function() {
        $('select[name="report_costs[usage][]"]').each(function() {
            let row = $(this).closest('tr');
            let usage = $(this).val();
    
            // 分類の更新
            if (usage === '' || usage === 'タクシー' || usage === '宿泊費' || usage.startsWith('その他')) {
                row.find('textarea[name="report_costs[title][]"]').attr('placeholder', '例）雑費');
                row.find('select[name="report_costs[route][]"]').val('').addClass('select-disabled');
                row.find('select[name="report_costs[route][]"] option').not(':first').hide();
            } else {
                row.find('textarea[name="report_costs[title][]"]').attr('placeholder', '例）新宿→原宿');
                row.find('select[name="report_costs[route][]"]').removeClass('select-disabled');
                row.find('select[name="report_costs[route][]"] option').show();
            }
        });
    });
});
    // 行の削除ボタン表示
    function addRemoveButton()
    {
        $('.js-dynamic-row').on({
            'mouseenter' : function() {
                $(this).find('.js-remove-report-cost').show();
            },
            'mouseleave' : function(){
                $(this).find('.js-remove-report-cost').hide();
            }
        });
    }
